import axios, { AxiosResponse } from 'axios';
import {
  TBatchGallery,
  TFindOneBatchGallery,
} from '../../../types/TBatchGallery';

export const findOneBatchGallery = async ({
  batchGalleryId,
  isFetching,
  userAccessToken,
}: TFindOneBatchGallery): Promise<{
  status: 'SUCCESS' | 'ERROR';
  data: TBatchGallery | object;
}> => {
  try {
    if (isFetching) isFetching(true);

    const { data }: AxiosResponse<TBatchGallery> = await axios.get(
      `${process.env.REACT_APP_SAAS_BATCH_GOOGLE_MODULES}/gallery-batch/${batchGalleryId}`,
      {
        headers: {
          Authorization: `Bearer ${userAccessToken}`,
        },
      }
    );
    return {
      status: 'SUCCESS',
      data,
    };
  } catch (err: any) {
    return {
      status: 'ERROR',
      data: err.response,
    };
  } finally {
    if (isFetching) isFetching(false);
  }
};
